export default class ArenaSeance {
    Id: number = 0;
    EventCode?: number;
    Name: string = '';
    EventId?: number;
    EventName: string = '';
    BeginDate?: moment.Moment;
    EndDate?: moment.Moment;
    SaleEndDate?: moment.Moment;
}